import CadastrosIndividuais from '../pages/VinculoAcompanhamento/CadastrosIndividuais/CadastrosIndividuais'
import CadastrosIndividuaisPorEquipeAcs from '../pages/VinculoAcompanhamento/CadastrosIndividuais/PorEquipeAcs'
import CadastrosIndividuaisPorAcs from '../pages/VinculoAcompanhamento/CadastrosIndividuais/PorAcs'

export default [
  {
    path: '/cadastros-individuais',
    component: () =>
      import('@/pages/VinculoAcompanhamento/CadastrosIndividuais/Template.vue'),
    children: [
      {
        path: '/cadastros-individuais/acs',
        component: CadastrosIndividuais,
      },
      {
        path: '/cadastros-individuais/profissional',
        component: CadastrosIndividuaisPorAcs,
      },
      {
        path: '/cadastros-individuais/equipe/acs',
        component: CadastrosIndividuaisPorEquipeAcs,
      },
    ],
  },
]
